import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ExportYearlyBalanceModal from 'modules/shift_management/components/ShiftManagement/ExportYearlyBalanceModal'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const ExportAnnualBalanceComponent = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [{ view }] = useSchedule()
  const [{ canSeeTimeBalanceExport }] = usePermissions()

  if (!canSeeTimeBalanceExport) return null

  return (
    <ResponsivePage.Body>
      <ExportYearlyBalanceModal
        onClose={() =>
          navigate(
            navigation.shifts.customViewGroup.fullPath({
              viewType: view.viewType,
              groupType: view.groupType,
              year: view.startRangeYear,
              month: view.startRangeMonth,
              day: view.startRangeDay,
            })
          )
        }
        from="shift-menu"
      />
    </ResponsivePage.Body>
  )
}

const ExportAnnualBalance = observer(ExportAnnualBalanceComponent)

export default ExportAnnualBalance
